import { faPenField, faSackDollar } from '@fortawesome/pro-solid-svg-icons';
import { Dialog, Text, Flex, Button, Icon, Avatar } from '@scale/scaleui-radix';
import { numberToDollars } from 'react-scale/components/scalers/tasks/OutlierTaskHeader/utils';
import { useState } from 'react';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';

export const PreAssessmentModal = ({
  userId,
  assessmentBonus,
}: {
  userId: string;
  assessmentBonus: number | undefined;
}) => {
  const [open, setOpen] = useState(true);

  const icon = assessmentBonus ? faSackDollar : faPenField;
  const title = assessmentBonus
    ? 'This assessment has a pass reward'
    : 'Pass the assessment before tasking';
  const description = assessmentBonus
    ? `You'll receive an additional ${numberToDollars(
        assessmentBonus,
      )} if you pass the entire assessment. `
    : 'You can start tasking after passing the entire assessment. ';

  const preAssessmentModalFlag = useUnleashFeatureFlag(
    'pre-assessment-modal',
    {
      userId,
    },
    false,
  );

  if (!assessmentBonus && !preAssessmentModalFlag) {
    return null;
  }

  return (
    <Dialog.Root open={open}>
      <Dialog.Content className="relative">
        <Flex direction="column" align="center" justify="center" gap="5" height="100%">
          <Avatar
            size="9"
            fallback={<Icon icon={icon} label="empty" color="accent" size="4" />}
            color="accent"
            radius="full"
          />
          <Flex direction="column" align="center" gap="3">
            <Text size="6" weight="medium">
              {title}
            </Text>
            <Text size="2" weight="light" color="neutral">
              {description}
              This project will be no longer available to you if you fail the assessment.
            </Text>
          </Flex>
          <Button onClick={() => setOpen(false)} className="cursor-pointer bg-[#1B0030]">
            Continue
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};
